import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import DatePicker from '../../../../components/utils/datepicker';

import { FaTimes, FaFilter } from 'react-icons/fa';
import Paginacao from '../../../../components/utils/paginacao';

const HistoricoProdutoModal = ({ onClose, produto }) => {
    const [movimentacoes, setMovimentacoes] = useState([]);
    const [filtroData, setFiltroData] = useState(new Date());
    const [error, setError] = useState(null);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10;

    const fetchMovimentacoes = async (page = 1) => {
        setError(null);

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        try {
            const params = new URLSearchParams({
                page: page,
                limit: limit
            });
            
            if (filtroData) {
                const dataISO = filtroData instanceof Date
                    ? filtroData.toISOString().split('T')[0]
                    : filtroData;
                params.append('data', dataISO);
            }
            
            const response = await api.get(`/produtos-movimentacao/${produto.id_produto}?${params}`);
            
            Swal.close();
            setMovimentacoes(response.data.records || []);
            setTotalPages(Math.ceil(response.data.totalRegistros / limit) || 1);
        } catch (err) {
            Swal.close();
            setError('Erro ao carregar o histórico de movimentações.');
        }
    };

    useEffect(() => {
        if (produto?.id_produto) {
            fetchMovimentacoes(currentPage);
        }
    }, [produto, currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleFiltrar = () => {
        if (!filtroData) {
            Swal.fire('Erro', 'Por favor, informe uma data para filtrar.', 'error');
            return;
        }

        setCurrentPage(1);
        fetchMovimentacoes(1);
    };

    const formatarDataHora = (dataHora) => {
        return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
    };

    const getOperacaoLabel = (operacao) => {
        switch (operacao) {
            case 'entrada':
                return <span className="badge bg-success">Entrada</span>;
            case 'saida':
                return <span className="badge bg-danger">Saída</span>;
            default:
                return <span className="badge bg-secondary">{operacao}</span>;
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Histórico de Movimentações</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row mt-2">
                            <div className="col-12">
                                <h6 className="mb-4"><strong>Produto:</strong> {produto?.nome}</h6>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4 col-12">
                                <label className="form-label fw-bold">Data</label>
                                <DatePicker
                                    selected={filtroData}
                                    onChange={(date) => setFiltroData(date)}
                                    popperModifiers={[
                                        {
                                            name: 'preventOverflow',
                                            options: {
                                                rootBoundary: 'viewport'
                                            }
                                        }
                                    ]}
                                    popperProps={{
                                        strategy: 'fixed'
                                    }}
                                />
                            </div>
                            <div className="col-md-8 col-12 d-flex align-items-end justify-content-end mt-lg-0 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-custom-primary"
                                    onClick={handleFiltrar}
                                >
                                    <FaFilter /> Filtrar
                                </button>
                            </div>
                        </div>

                        {error ? (
                            <p className="error-message text-danger">{error}</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="table-custom-primary">
                                        <tr>
                                            <th>Operação</th>
                                            <th>Quantidade</th>
                                            <th>Observação</th>
                                            <th>Criado Por</th>
                                            <th>Data e Hora</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {movimentacoes.length > 0 ? (
                                            movimentacoes.map((movimentacao, index) => (
                                                <tr key={index}>
                                                    <td>{getOperacaoLabel(movimentacao.operacao)}</td>
                                                    <td className="text-nowrap">{movimentacao.quantidade}</td>
                                                    <td>{movimentacao.observacao}</td>
                                                    <td className="text-nowrap">{movimentacao.criado_por}</td>
                                                    <td className="text-nowrap">{formatarDataHora(movimentacao.data_hora)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    Nenhuma movimentação encontrada
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="d-flex justify-content-end mt-4">
                            <Paginacao
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                            <FaTimes /> Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoricoProdutoModal; 